<template>
    <div class="container">
        <template v-if="panorama">
            <!-- 普通视频 -->
            <template v-if="panorama.index_type == 1">
                <!-- 这个是一进来的封面 -->
                <template v-if="index == 0">
                    <div class="bg_video_wrap">
                        <!-- 背景视频 -->
                        <HomeNormalVideo :isBg="true" :src="panorama.video" :poster="panorama.video_image" :muted="true" :autoplay="true" :loop="true"/>
                        <!-- 文字 -->
                        <div class="text_wrap">
                            <p class="text" v-html="tobr(panorama.index_video_desc)"></p>
                            <div class="btn_group">
                                <div class="btn" @click.stop="playVideo">{{$t('homeBtn1')}}</div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 这部分是点击播放视频 -->
                <template v-if="index == 1">
                    <!-- 普通视频，这尼玛也分全景和普通？？？ -->
                    <template v-if="panorama.video_type == 1">
                        <div class="bg_video_wrap">
                            <HomeNormalVideo ref="homeVideo" :isBg="false" :src="panorama.panorama" @play="isFirstPlay = true; ended = false" @ended="ended = true"/>
                            <div class="btn1 type2" :class="{active: isFirstPlay}" v-if="!ended" @click="showYearsPopup">{{$t('homeBtn')}}</div>
                            <div class="btn_group ended" v-if="ended">
                                <div class="btn1 replay active" @click="replay">{{$t('replay')}}</div>
                                <div class="btn1 active" @click="showYearsPopup">{{$t('homeBtn')}}</div>
                            </div>
                        </div>
                    </template>
                    <!-- 全景视频 -->
                    <template v-if="panorama.video_type == 2">
                        <VideoSphereViewer :src="panorama.panorama" :poster="panorama.video_cover" :pan="panorama.index_pan" :tilt="panorama.index_tilt" :fov="panorama.index_fov" @firstPlay="isFirstPlay = true" @play="homeVideoPlayBtnTap"/>
                        <div class="btn1" :class="{active: isFirstPlay}" @click="showYearsPopup">{{$t('homeBtn')}}</div>
                    </template>
                    <template v-if="panorama.video_desc">
                        <!-- 左下角视频音频/字幕 -->
                        <VideoPopup ref="videoPopup" :isHideBGMusic="true" :text="panorama.video_desc"/>
                    </template>
                </template>
            </template>
            <!-- 全景视频 -->
            <template v-if="panorama.index_type == 2">
                <VideoSphereViewer :src="panorama.panorama" :poster="panorama.video_cover" :pan="panorama.index_pan" :tilt="panorama.index_tilt" :fov="panorama.index_fov" @firstPlay="isFirstPlay = true" @play="homeVideoPlayBtnTap"/>
                <div class="btn1" :class="{active: isFirstPlay}" @click="showYearsPopup">{{$t('homeBtn')}}</div>
                <template v-if="panorama.video_desc || backgroundAudio">
                    <!-- 左下角视频音频/字幕 -->
                    <VideoPopup ref="videoPopup" :text="panorama.video_desc"/>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import HomeNormalVideo from '../components/homeNormalVideo.vue';
import VideoPopup from '../components/videoPopup.vue';
import VideoSphereViewer from '../components/videoSphereViewer.vue';
export default {
    name: "home",
    data() {
        return {
            panorama: null, //data
            isFirstPlay: false, //第一次播放，封面、点击手势控制
            index: 0, //普通视频背景的首页，页码
            ended: false, //播放结束
        };
    },
    computed: {
        ...mapState(['backgroundAudio']),
        tobr(){
            return (str)=>{
                if(str){
                    return str.replace(/\r\n/g,"<br>")
                }else{
                    return ''
                }
            }
        }
    },
    components: {
        VideoSphereViewer,
        VideoPopup,
        HomeNormalVideo
        
    },
    mounted() {
        this.setHomeData();
    },
    destroyed() {},
    watch: {},
    methods: {
        homeVideoPlayBtnTap(){
            // trackEvent
            this.$trackEvent('welcome-video-play');
        },
        setHomeData() {
            let self = this;
            this.$store.dispatch('getHomeData').then((res) => {
                self.panorama = res;
            })
        },
        showYearsPopup() { 
            this.$store.state.isShowYearsPopup = true;
            this.$store.state.yearPageActiveIndex = 0;
            this.$store.state.yearsActiveIndex = 0;
            
            // trackEvent
            this.$trackEvent('start-my-tour');
        },
        replay(){
            this.$refs.homeVideo.$refs.video.play();
            this.ended = false;
        },
        playVideo(){
            this.index = 1;
            this.$nextTick(()=>{
                if(this.panorama.video_type == 1){
                    this.$refs.homeVideo.$refs.video.play();
                }
                // if(this.panorama.video_type == 2){
                //     this.$refs.VrVideo.setUtovr();
                // }
            })
        },
    },
};
</script>

<style scoped lang="scss">
.bg_video_wrap{
    width: 100%;
    height: 100%;
    @media only screen and (max-width: 640px) {
        height: auto;
        position: relative;
    }
}
.container{
    overflow: hidden;
}
.btn1{
    width: 2.4rem;
    height: .6rem;
    font-size: .16rem;
    font-weight: bold;
    position: absolute;
    bottom: .9rem;
    left: 50%;
    margin-left: -1.2rem;
    z-index: 9;
    background: #fff;
    border-radius: .04rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    &.type2{
        left: auto;
        right: .5rem;
        bottom: 0;
        @media only screen and (max-width: 640px) {
            width: 6.5rem;
            height: .72rem;
            background: #b22526;
            color: #fff;
            bottom: -1.12rem;
            &::after{
                background-image: url('../assets/images/icon_home_btn_arrow_02.png');
            }
        }
    }
    &.active{
        animation: showBtn .5s 2s both;
    }
    @keyframes showBtn {
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
    @media only screen and (max-width: 640px) {
        bottom: 2rem;
        font-size: .2rem;
    }
    &::after{
        content: "";
        display: block;
        width: .11rem;
        height: .2rem;
        margin-left: .12rem;
        background: url('../assets/images/icon_home_btn_arrow_01.png') no-repeat 0/100%;
        animation: btnArrow 1s linear alternate infinite;
    }
    @keyframes btnArrow {
        0%{
            transform: translate(-50%, 0);
        }
        100%{
            transform: translate(50%, 0);
        }
    }
}
.text_wrap{
    position: absolute;
    left: 1.3rem;
    top: 30%;
    font-size: .3rem;
    color: #fff;
    font-weight: bold;
    text-shadow: 0 0 .1rem rgba($color: #000000, $alpha: .5);
    .text{
        margin-bottom: .2rem;
    }
    @media only screen and (max-width: 640px) {
        .text{
            margin-bottom: 1rem;
            margin-left: .24rem;
        }
        top: auto;
        left: 0;
        bottom: -1.2rem;
        font-size: .35rem;
    }
}
.btn_group{
    display: flex;
}
.btn{
    height: .6rem;
    background: #c22924;
    line-height: .6rem;
    padding: 0 .4rem;
    border-radius: .1rem;
    color: #fff;
    font-size: .16rem;
    cursor: pointer;
    @media only screen and (max-width: 640px) {
        width: 6.5rem;
        height: .72rem;
        line-height: .72rem;
        margin: 0 .5rem;
        text-align: center;
        font-size: .2rem;
    }
}
.ended{
    position: absolute;
    z-index: 1;
    bottom: .9rem;
    right: 28%;
    .btn1{
        position: relative;
        left: auto;
        bottom: auto;
        margin: 0 .15rem;
        background: #b22526;
        color: #fff;
        &::after{
            background-image: url('../assets/images/icon_home_btn_arrow_02.png');
        }
        &.replay{
            &::after{
                width: .27rem;
                height: .27rem;
                background-image: url('../assets/images/icon_replay2.png');
                animation: none;
            }
        }
    }
    @media only screen and (max-width: 640px) {
        bottom: -1.12rem;
        width: 6.5rem;
        right: .5rem;
        .btn1{
            margin: 0;
            height: .72rem;
            flex: 1;
            &.replay{
                flex: none;
                width: 2.2rem;
                margin-right: .3rem;
            }
        }
    }
}
</style>